import { fetchCanvasEvents } from './canvas';
import { saveUserCanvasUrl, getUserCanvasUrl, saveCanvasCourses } from './firebaseDatabase';
import { auth } from '../firebase';

export const loadCanvasData = async () => {
    if (!auth.currentUser) {
        console.log('Cannot load Canvas data: No Firebase user');
        return null;
    }

    const userId = auth.currentUser.uid;
    console.log('Loading Canvas URL for user:', userId);

    try {
        const savedUrl = await getUserCanvasUrl(userId);

        if (savedUrl) {
            console.log('✅ Canvas URL loaded from database:', savedUrl);
            const { upcoming, all } = await fetchCanvasEvents(savedUrl);

            let courses = []; // ← moved outside the if block

            if (all.length > 0) {
                const courseMap = new Map();
                all.forEach(event => {
                    if (event.courseId && !courseMap.has(event.courseId)) {
                        courseMap.set(event.courseId, {
                            id: event.courseId,
                            name: event.courseInfo?.raw?.replace(/-[^-]+$/, '').trim() || `Course ${event.courseId}`,
                            teacher: event.courseInfo?.teacher || null,
                            period: event.courseInfo?.period || null,
                            rawInfo: event.courseInfo?.raw || null,
                            courseUrl: `https://mvla.instructure.com/courses/${event.courseId}`
                        });
                    }
                });

                courses = Array.from(courseMap.values()); // ← assign here
                console.log('Canvas courses found:', courses);
                localStorage.setItem('canvasCourses', JSON.stringify(courses));
                await saveCanvasCourses(userId, courses);
            }

            return {
                url: savedUrl,
                events: upcoming || [],
                courses: courses // ← now accessible
            };
        } else {
            console.log('No Canvas URL found in database for user:', userId);
        }

        return null;
    } catch (error) {
        console.error('Error loading Canvas data:', error);
        return null;
    }
};

export const saveCanvasData = async (canvasUrl) => {
    if (!auth.currentUser) {
        console.log('Cannot save Canvas data: No Firebase user');
        return false;
    }

    if (!canvasUrl) {
        console.log('Cannot save Canvas data: No URL provided');
        return false;
    }

    const userId = auth.currentUser.uid;
    console.log('Saving Canvas URL for user:', userId, 'URL:', canvasUrl);

    try {
        const result = await saveUserCanvasUrl(userId, canvasUrl);
        if (result) {
            console.log('✅ Canvas URL saved successfully');
        }
        return result;
    } catch (error) {
        console.error('Error saving Canvas data:', error);
        return false;
    }
};

export const refreshCanvasData = async (canvasUrl) => {
    if (!canvasUrl) {
        throw new Error('No Canvas URL configured');
    }

    const { upcoming, all } = await fetchCanvasEvents(canvasUrl);

    localStorage.setItem('canvasEvents', JSON.stringify(upcoming));

    let courses = [];

    if (all.length > 0) {
        const courseMap = new Map();
        all.forEach(event => {
            if (event.courseId && !courseMap.has(event.courseId)) {
                courseMap.set(event.courseId, {
                    id: event.courseId,
                    name: event.courseInfo?.raw?.replace(/-[^-]+$/, '').trim() || `Course ${event.courseId}`,
                    teacher: event.courseInfo?.teacher || null,
                    period: event.courseInfo?.period || null,
                    rawInfo: event.courseInfo?.raw || null,
                    courseUrl: `https://mvla.instructure.com/courses/${event.courseId}`
                });
            }
        });

        courses = Array.from(courseMap.values());
        localStorage.setItem('canvasCourses', JSON.stringify(courses));

        if (auth.currentUser) {
            await saveCanvasCourses(auth.currentUser.uid, courses);
        }
    }

    return { events: upcoming, courses };
};